// src/routes/Admin.js
import Login from '../pages/admin/login/Login';
import Register from '../pages/admin/register/Register';
import Dashboard from '../pages/admin/dashboard/Dashboard';
import BannerList from '../pages/admin/banner/BannerList';
import AddUpdateBanner from '../pages/admin/banner/AddUpdateBanner';
import UserList from '../pages/admin/user/UserList';
import AddUpdateUser from '../pages/admin/user/AddUpdateUser';
import PropertyList from '../pages/admin/property/PropertyList';
import AddUpdateProperty from '../pages/admin/property/AddUpdateProperty';
import ContactList from '../pages/admin/contactUs/ContactList';
import ContactUsForm from '../pages/admin/contactUs/AddUpdateContactUs';
const Admin = [
    {
    path: '/login',
    element: <Login/>,
  },
    {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
   {
    path: '/bannerList',
    element: <BannerList />,
  },
  {
    path: '/banner/addUpdateBanner',
    element: <AddUpdateBanner />,
  },
  {
    path: '/editBanner/:id',
    element: <AddUpdateBanner />,
  },

  {
    path: '/userList',
    element: <UserList />,
  },
  
  {
    path: '/contactList',
    element: <ContactList />,
  },
   {
    path: '/editContactUsForm/:id',
    element: <ContactUsForm/>,
  },
  {
    path: '/user/addUpdateUser',
    element: <AddUpdateUser />,
  },
  {
    path: '/editUser/:id',
    element: <AddUpdateUser />,
  },
  {
    path: '/propertyList',
    element: <PropertyList />,
  },
  {
    path: '/property/addUpdateProperty',
    element: <AddUpdateProperty />,
  },
  {
    path: '/editProperty/:id',
    element: <AddUpdateProperty />,
  },
];

export default Admin;
